import { ArucoPicture } from '@modules/aruco/models/aruco-picture';
import { PictureProviderModuleComponentOutputs } from '../models/picture-provider-module-component';

export const toPictureProviderOutput = (
  picture: ArucoPicture,
  pictureExists: boolean,
): PictureProviderModuleComponentOutputs => ({
  picture,
  isNewPicture: !pictureExists,
});
